import { ICON_TYPES } from '../constants';

export const ArrowRightIcon = (): JSX.Element => {
  return (
    <svg viewBox="0 0 25 40" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.3332 20L-0.000164255 4.66667L4.6665 0L24.6665 20L4.6665 40L-0.000164255 35.3333L15.3332 20Z" />
    </svg>
  );
};

ArrowRightIcon.iconType = ICON_TYPES.ARROW_RIGHT;
